import { create } from "zustand";
import { getHomePageItemAccessApi } from "api/menu";
import { PageAccessByMenu } from "interface/user";
import { PageTypePath } from "utils/pages";

interface HomePageAccess {
	registration?: PageAccessByMenu;
	salesNote?: PageAccessByMenu;
	landingNote?: PageAccessByMenu;
	home?: PageAccessByMenu;
}

interface HomePageAccessState {
	homePageAccess: HomePageAccess | null;
	loading: boolean;
	loadHomePageAccess: () => Promise<void>;
	resetHomePageAccess: () => void;
}

export const useHomePageAccessStore = create<HomePageAccessState>()((set, get) => ({
	homePageAccess: null,
	loading: false,

	loadHomePageAccess: async () => {
		const { homePageAccess, loading } = get();
		const currentPath = window.location.pathname;

		if (loading || homePageAccess || currentPath !== "/") {
			return;
		}

		set({ loading: true });
		try {
			const homeAccess = await getHomePageItemAccessApi();

			console.log('homeAccess', homeAccess);

			const registrationAccess = homeAccess.find(
				(item) => item.path === PageTypePath.RegistrationList,
			);
			const salesNoteAccess = homeAccess.find(
				(item) => item.path === PageTypePath.SalesNotesList,
			);
			const landingNoteAccess = homeAccess.find(
				(item) => item.path === PageTypePath.LandingNoteList,
			);
			const homePageAccess = homeAccess.find(
				(item) => item.path === PageTypePath.Home,
			);

			set({
				homePageAccess: {
					registration: registrationAccess,
					salesNote: salesNoteAccess,
					landingNote: landingNoteAccess,
					home: homePageAccess,
				},
			})

		}
		catch (err) {
			console.log(err);
		}
		 finally {
			set({ loading: false });
		}
	},
	resetHomePageAccess: () =>
		set({
			homePageAccess: null,
			loading: false,
		}),
}));
// useHomePageAccessStore.getState().loadHomePageAccess();